import { cn } from "../lib/utils";

// Grid positions for scattered layout (5 rows x 5 cols)
// 9 positions with hasCard: true to match the 9 photos fetched in Home.js
const tiles = [
  // Row 0
  { row: 0, col: 0, hasCard: true },
  { row: 0, col: 2, hasCard: true },
  { row: 0, col: 4, hasCard: true },
  // Row 1
  { row: 1, col: 1, hasCard: true },
  { row: 1, col: 3, hasCard: true },
  // Row 2
  { row: 2, col: 0, hasCard: true },
  { row: 2, col: 2, hasCard: true },
  { row: 2, col: 4, hasCard: true },
  // Row 3
  { row: 3, col: 1, hasCard: false },
  { row: 3, col: 3, hasCard: false },
  // Row 4
  { row: 4, col: 0, hasCard: false },
  { row: 4, col: 2, hasCard: true },
  { row: 4, col: 4, hasCard: false },
];

export function Integrations({ photos = [] }) {
  // Assign fetched photos to card positions
  let photoIndex = 0;
  const tilesWithPhotos = tiles.map((tile) => {
    if (tile.hasCard && photoIndex < photos.length) {
      return { ...tile, photo: photos[photoIndex++] };
    }
    return { ...tile, photo: null };
  });

  return (
    <div className="mx-auto grid max-w-5xl grid-cols-1 gap-12 p-4 md:grid-cols-2 md:items-center">
      {/* Left Content */}
      <div className="max-w-xl space-y-5">
        <h2 className="font-medium text-4xl text-gray-900 tracking-tight sm:text-5xl">
          People <span className="text-primary">Love Us</span>
        </h2>
        <p className="text-lg text-gray-500 leading-8">
          People love Engaged Manila for making brand-influencer collaboration simple.
          Even during our beta, our early users can't stop talking about it.
        </p>
        <ul className="space-y-3 pt-2">
          {[
            "Connect with brands that fit your content",
            "Get paid for authentic reviews",
            "Track your growth with real analytics",
          ].map((item, i) => (
            <li key={i} className="flex items-center gap-3">
              <span className="flex items-center justify-center h-6 w-6 rounded-full bg-primary/10 shrink-0">
                <svg className="h-3.5 w-3.5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span className="text-base text-gray-700">{item}</span>
            </li>
          ))}
        </ul>
        <a
          href="/register"
          className="inline-flex items-center justify-center px-7 py-3.5 bg-primary hover:bg-primary-dark text-white font-semibold rounded-full shadow-lg transition-colors duration-300 cursor-pointer"
        >
          Get Started
        </a>
      </div>

      {/* Right Content - Scattered profile photo cards with mask */}
      <div className="place-items-end">
        <div
          className="relative"
          style={{
            width: 360,
            height: 360,
            maskImage: "radial-gradient(ellipse at center, black, black, transparent)",
            WebkitMaskImage: "radial-gradient(ellipse at center, black, black, transparent)",
          }}
        >
          {tilesWithPhotos.map((tile, idx) => (
            <PhotoCard key={`tile-${idx}`} {...tile} />
          ))}
        </div>
      </div>
    </div>
  );
}

function PhotoCard({ row, col, photo }) {
  const cellSize = 72;
  const cardSize = 64;

  if (!photo) {
    // Empty decorative tile
    return (
      <div
        className={cn(
          "absolute flex items-center justify-center rounded-lg border",
          "bg-gray-50 border-gray-100"
        )}
        style={{
          width: cardSize,
          height: cardSize,
          left: col * cellSize,
          top: row * cellSize,
        }}
      >
        <div className="w-3 h-3 rounded-full bg-gray-200" />
      </div>
    );
  }

  return (
    <div
      className="absolute flex items-center justify-center rounded-xl border bg-white shadow-md p-1 hover:shadow-lg hover:z-30 hover:scale-105 transition-all duration-300 overflow-hidden"
      style={{
        width: cardSize,
        height: cardSize,
        left: col * cellSize,
        top: row * cellSize,
      }}
    >
      <img
        src={photo}
        alt="Engaged Manila community member"
        className="w-full h-full rounded-lg object-cover"
      />
    </div>
  );
}

export default Integrations;
